import { BroadcastApiStatus, BroadcastManagerState } from "@dreamcam/web-sdk";
import { Env } from "../../settings/Env";
const StateToStatus = {};
StateToStatus[BroadcastManagerState.UNINITIALIZED] = BroadcastApiStatus.OFFLINE;
StateToStatus[BroadcastManagerState.OFFLINE] = BroadcastApiStatus.OFFLINE;
StateToStatus[BroadcastManagerState.AWAY] = BroadcastApiStatus.AWAY;
StateToStatus[BroadcastManagerState.PUBLIC] = BroadcastApiStatus.PUBLIC;
StateToStatus[BroadcastManagerState.PRIVATE_SHOW] = BroadcastApiStatus.PRIVATE;
StateToStatus[BroadcastManagerState.MY_PRIVATE_SHOW] = BroadcastApiStatus.PRIVATE;
StateToStatus[BroadcastManagerState.SPY_SHOW] = BroadcastApiStatus.PRIVATE;
export class MessengerPanelData {
    constructor() {
        this._selectedModelId = null;
        this._selectedChat = null;
        this._pinnedData = null;
        this._isTyping = false;
        this._broadcastApiStatus = BroadcastApiStatus.OFFLINE;
    }
    get pinnedModelId() {
        return this._pinnedData?.modelId ?? null;
    }
    setPinnedModelId(modelId) {
        this._pinnedData = modelId === null ? null : { modelId };
    }
    setSelectedModelId(modelId) {
        this._selectedModelId = modelId;
    }
    setSelectedChat(chat) {
        this._selectedChat = chat;
    }
    get _isPinned() {
        return this._pinnedData !== null
            && this._pinnedData.modelId === this._selectedModelId;
    }
    get selectedModelId() { return this._selectedModelId; }
    ;
    get modelNickname() {
        return (this._isPinned ? this._pinnedData.modelNickname : this._selectedChat?.participant.username) ?? null;
    }
    ;
    get modelProfileImageUrl() {
        return (this._isPinned ? this._pinnedData.modelProfileImageUrl : this._selectedChat?.participant.avatar)
            ?? Env.lobby.gallery.defaultPreview.path;
    }
    get broadcastApiStatus() {
        return this._isPinned
            ? StateToStatus[this._pinnedData?.broadcastManagerState ?? BroadcastManagerState.UNINITIALIZED]
            : this._broadcastApiStatus;
    }
    get isFavorite() {
        return (this._isPinned ? this._pinnedData.isFavorite : this._selectedChat?.participant.is_favorite) ?? false;
    }
    get isTyping() {
        return this._isTyping;
    }
    set isTyping(value) {
        this._isTyping = value;
    }
    get isBanned() {
        return this._selectedChat?.participant.reverse_block_data.is_blocked === true;
    }
    get lastBroadcast() {
        const chatLastSeenString = this._selectedChat?.participant.last_seen;
        const chatLastSeenDate = chatLastSeenString ? new Date(chatLastSeenString) : undefined;
        return (this._isPinned ? this._pinnedData.lastBroadcast : chatLastSeenDate) ?? null;
    }
    get chat() {
        return this._selectedChat;
    }
    setPinnedModelNickname(value) {
        if (this._pinnedData)
            this._pinnedData.modelNickname = value;
    }
    setPinnedModelProfileImageUrl(value) {
        if (this._pinnedData)
            this._pinnedData.modelProfileImageUrl = value;
    }
    get pinnedBroadcastManagerState() {
        return this._pinnedData?.broadcastManagerState ?? null;
    }
    setPinnedBroadcastManagerState(value) {
        if (this._pinnedData)
            this._pinnedData.broadcastManagerState = value;
    }
    setPinnedIsFavorite(isFavorite, force) {
        if (this._pinnedData) {
            if (force || this._pinnedData.modelId === this._selectedModelId)
                this._pinnedData.isFavorite = isFavorite;
        }
    }
    setBroadcastApiStatus(value) {
        this._broadcastApiStatus = value;
    }
    setPinnedLastBroadcast(value) {
        if (this._pinnedData)
            this._pinnedData.lastBroadcast = value ?? undefined;
    }
}
